module.exports = __webpack_public_path__ + "img/content-huayi.3e7ff1d7.png";